<script>
    const descriptions = [
        {
            id: 'Exploration',
            first_paragraph: 'Changing the world requires exploring, testing and scaling as fast as possible.' +
                'Whether you are coming to DraperU with defined objectives or are working through ' +
                'multiple options, this is the perfect place for you.',
            second_paragraph: 'Each day you’ll work with your cohort to identify bottlenecks, break down ' +
                'assumptions and iterate on solutions. Fail and fail again until I succeed is a motto we live ' +
                'by! We also add industry experts, mentors and investors to the mix who through 1:1 conversations ' +
                'and experiential learning, take your goals to the next level',
            img: 'images/Providing_Everything_Images/exploration.png',
        },
        {
            id: 'Accerelation',
            first_paragraph: 'We’re building the future of learning and are the accelerant your career and' +
                'company needs, all we ask is that you show up and do the work.',
            second_paragraph: 'Through a tested blend of cohort based learning, 1:1 interactions and a space' +
                'that is literally a whiteboard (yes you can write anywhere), our programs offer a unique mix of' +
                'resources, capital and experts to go full speed ahead.',
            img: 'images/Providing_Everything_Images/acceleration.png',
        },
        {
            id: 'Networking',
            first_paragraph: 'By joining DraperU, you’ll learn from renowned leaders and' +
                'innovators who are already where you want to be.',
            second_paragraph: 'Not only that you will connect with a global community of innovators, entrepreneurs,'+
             'corporate leaders and investors. This is where you build lifelong connections that accelerate your goals'+
             ' and provide support when things are hard.',
            img: 'images/Providing_Everything_Images/networking.png',
        },
        {
            id: 'Heroism',
            first_paragraph: 'DraperU is an intensive, immersive experience, whether you do it online or in-person.',
            second_paragraph: 'You’ll develop the essential life skills you need to launch and sustain a successful ' +
            'venture, gain exposure to industry experts and network with other individuals who share your vision of ' +
            'changing the world. By the time you graduate, you’ll have gone from human to hero.',
            img: 'images/Providing_Everything_Images/Heroism.png',
        },
    ];
    let width;
    let distanceFromTop;
    let distance;
    let currentlySelected = 'Exploration';
    let selectedHeading = 'exploration';
    let slidingMbl;
    let currentSliding;
    let sliding;
    let waitingTime;
    let valueChangedByFunction = false;
    const sideNav = ['Exploration', 'Accerelation', 'Networking', 'Heroism'];
    export let scrollY;
    export let viewPortHeight;
    /**
     *
     * @param {string}element
     */
    function moveTo(element) {
        valueChangedByFunction = true;
        switch (element) {
        case 'Exploration':
            scrollY = distanceFromTop + 2;
            break;
        case 'Accerelation':
            scrollY = distanceFromTop + 158;
            break;
        case 'Networking':
            scrollY = distanceFromTop + 302;
            break;
        case 'Heroism':
            scrollY = distanceFromTop + 457;
        }
    }
    $: {
        if (currentSliding) {
            if (width >= 2000 && width < 3000) {
                distanceFromTop =
                currentSliding.offsetTop + viewPortHeight / 4;
            } else {
                distanceFromTop =
                currentSliding.offsetTop + viewPortHeight / 2;
            }
        }
    }
    $: {
        if (valueChangedByFunction) waitingTime = 200;
        else waitingTime = 0;

        setTimeout(function() {
            distance = scrollY - distanceFromTop;
            if (distance > 0) {
                if (distance < 156 ) {
                    currentlySelected = 'Exploration';
                    selectedHeading = 'exploration';
                } else if (distance < 300 ) {
                    currentlySelected = 'Accerelation';
                    selectedHeading = 'accerelation';
                } else if (distance < 455 ) {
                    currentlySelected = 'Networking';
                    selectedHeading = 'networking';
                } else {
                    currentlySelected = 'Heroism';
                    selectedHeading = 'heroism';
                }
            }
            valueChangedByFunction = false;
        }, waitingTime);
    }
    $: {
        if (width > 1024) currentSliding = sliding;
        else currentSliding = slidingMbl;
    }
</script>

<svelte:window bind:outerWidth={width} />

<div class="desktop-version">
    <h1 class="title">
        We inspire people and accelerate ideas by igniting the entrepreneurial
        spirit globally.
    </h1>
    <div class="containing-div" bind:this={sliding}>
        <div class="sliding-part">
            <section id="section">
                <div class="flex-container {currentlySelected}">
                    <div class="side-menu">
                        <div class="yellow-line {selectedHeading}">
                            <img
                            src="images/yellow_rectangle.png"
                            alt=" "
                        />  
                        </div>
                        <ul>
                            {#each sideNav as heading}
                                <li
                                    class={currentlySelected == heading ?
                                        'selected' :
                                        'unselected'}
                                    on:click={() => moveTo(heading)}
                                >
                                    {heading}
                                </li>
                            {/each}
                        </ul>
                    </div>
                   <div style="height: 45.444vw;  width:37.317vw;overflow:hidden">
                    <div class="description">
                        {#each descriptions as description}
                            <div class="start">
                                <div class="description-inner {description.id}">
                                    <img
                                        src={description.img}
                                        alt={description.id}
                                    />
                                    <p>{description.first_paragraph}</p>
                                    <p>{description.second_paragraph}</p>
                                </div>
                            </div>
                        {/each}
                    </div>
                   </div>
                </div>
                <div class="line" />
            </section>
        </div>
    </div>
</div>
<div class="mobile-version {currentlySelected}" bind:this={slidingMbl}>
    <p style="
    font-size: 5.607vw;
    width: 78.28vw;
    color: rgba(0, 32, 75, 1);
    font-weight: bold;
    margin-left: 7.002vw;
    line-height: 6.787vw;
    margin-bottom: 13.318vw;
    font-family:'inter';
">We inspire people and accelerate ideas by igniting the entrepreneurial spirit globally!</p>
    <div class="sticky-mbl">
        <div class="blue-container-mbl"><div class="yellow-bar" /></div>
        {#each sideNav as heading}
            <h3 class="{heading} heading-mbl" on:click={() => moveTo(heading)}>
                {heading}
            </h3>
        {/each}
        {#each descriptions as description}
            <div class="description-inner-mbl {description.id}">
                <img src={description.img} alt={description.id} />
                <p>{description.first_paragraph}</p>
                <p>{description.second_paragraph}</p>
            </div>
        {/each}
    </div>
</div>

<style>
    .desktop-version {
        display: block;
    }
    .mobile-version {
        display: none;
        height: 420vw;
    padding-top: 14.019vw;  
    }
    @media screen and (max-width: 1024px) {
        .desktop-version {
            display: none;
        }
        .mobile-version {
            display: block;
        }
    }
    #section {
        padding-left: 10.03%;
        padding-right: 15.339vw;
        height: 50.208vw;
        overflow: hidden;
        position: relative;
    }
    .description {
        margin-top: 2.125vw;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 46vw;
    }
    .yellow-line{
        margin-top: 4.3vw;
        position: absolute;
        margin-left: 5.404vw;
        transition: transform 1s, opacity 1s;
    }
    .exploration{
        transform: translateY(0); 
    }
    .accerelation{
        transform: translateY(7.2vw); 
    }
    .networking{
        transform: translateY(14.3vw); 
    }
    .heroism{
        transform: translateY(21.4vw); 
    }
    .start {
        transform: translate(37.33vw, 0);
    }
    .desktop-version .Accerelation .Exploration {
        transform: translate(-37.317vw, -44vw);
    }
    .desktop-version .Accerelation .Accerelation {
        transform: translate(-37.317vw, -46vw);
    }
    .desktop-version .Networking .Exploration {
        transform: translate(-37.317vw, -85vw);
    }
    .desktop-version .Networking .Accerelation {
        transform: translate(-37.317vw, -89vw);
    }
    .desktop-version .Networking .Networking {
        transform: translate(-37.317vw, -91vw);
    }
    .desktop-version .Heroism .Exploration {
        transform: translate(-37.317vw, -217vw);
    }
    .desktop-version .Heroism .Accerelation {
        transform: translate(-37.317vw, -174vw);
    }
    .desktop-version .Heroism .Networking {
        transform: translate(-37.317vw, -135vw);
    }
    .desktop-version .Heroism .Heroism {
        transform: translate(-37.317vw, -137vw);
    }
    /* .desktop-version .Accerelation .Exploration,
    .desktop-version .Networking .Accerelation,
    .desktop-version .Networking .Exploration,
    .desktop-version .Heroism .Exploration,
    .desktop-version .Heroism .Accerelation,
    .desktop-version .Heroism .Networking {
        transform: translate(50vw, -20vw);
        opacity: 0;
    }
    .desktop-version .Exploration .Exploration,
    .desktop-version .Accerelation .Accerelation,
    .desktop-version .Networking .Networking,
    .desktop-version .Heroism .Heroism {
        transform: translate(-37.317vw, 0);
        opacity: 1;
    }
    .desktop-version .Exploration .Accerelation,
    .desktop-version .Exploration .Networking,
    .desktop-version .Exploration .Heroism,
    .desktop-version .Accerelation .Networking,
    .desktop-version .Accerelation .Heroism,
    .desktop-version .Networking .Heroism {
        transform: translate(-37.317vw, 100vh);
        opacity: 0;
    } */
    .title {
        font-family: "Manrope";
        padding-left: 10.03%;
        margin-top: 6.614vw;
        font-weight: 500;
        font-size: 2.646vw;
        color: #00204b;
        line-height: 3.3vw;
        max-width: 72vw;
        margin-bottom: 5.291vw;
    }
    .flex-container {
        display: flex;
        justify-content: space-between;
    }
    .side-menu > ul {
        list-style-type: none;
    }
    .side-menu > ul li {
        font-size: 2.067vw;
        cursor: pointer;
        margin-top: 4.05vw;
        margin-left: 3.918vw;
        /* transition: font-weight 0.8s, font-size 0.9s; */
    }
    ul li.unselected {
        font-weight: 300;
        color: #b2bcc9;
    }
    ul li.selected {
        font-weight: 600;
        color: #00204b;
        /* border-left: 0.465vw solid #f7e05f; */
        padding-left: 0.996vw;
        animation-name: itemList;
        animation-duration: 1s;
    }
    @keyframes itemList {
        0%   {opacity: 0.2;}
        25%  {opacity: 0.4;}
        50%  {opacity: 0.8;}
        100% {opacity: 1;}
    }
    .description img {
        border-radius: 1.992vw;
        height: 22.444vw;
        width: 37.317vw;
        margin-bottom: 3.652vw;
    }
    .description-inner {
        transition: transform 1s, opacity 1s;
        transform: translate(-37.317vw, 0);
        position: absolute;
    }
    .description-inner > p {
        margin-bottom: 1.3vw;
        color: #00204b;
        font-weight: 300;
        line-height: 1.461vw;
        font-size: 1.19vw;
    }

    .line {
        position: absolute;
        left: 46.9%;
        right: 27.53%;
        top: 47.124vw;
        border: 1px solid #3c74c0;
    }
    .containing-div {
        height: 95.208vw;
        margin-top: -2.1vw;
    }
    .sliding-part {
        position: sticky;
        top: 0;
        width: 100%;
    }
    .blue-container-mbl {
        background-color: #00204b;
        height: 120.327vw;
        width: 87.617vw;
        border-radius: 7.009vw;
        margin-bottom: 8.879vw;
        position: absolute;
        right: 6.192vw;
        top: 28.972vw;
        transition: all 1s;
    }
    .yellow-bar {
        border-left: 0.467vw solid #f7e05f;
        height: 5.374vw;
        margin-left: 26.636vw;
        margin-top: 5.607vw;
        z-index: 10;
    }
    .Exploration .blue-container-mbl {
        top: 5.607vw !important;
    }
    .sticky-mbl {
        height: 184.579vw;
        position: sticky;
        width: 100%;
        top: 30vw;
    }
    .heading-mbl {
        position: absolute;
    }
    .description-inner-mbl {
        position: absolute;
        opacity: 0;
        left: 15.421vw;
        transition: opacity 0.8s;
    }
    .description-inner-mbl > img {
        width: 56.542vw;
        height: 33.995vw;
        border-radius: 7.009vw;
        margin-left: 6.075vw;
        margin-bottom: 11.098vw;
    }
    .description-inner-mbl > p {
        color: white;
        width: 69.159vw;
        font-weight: 300;
        font-size: 2.804vw;
        line-height: 3.505vw;
        text-align: center;
    }
    .heading-mbl {
        font-weight: 300;
        color: #00204b;
        left: 37.383vw;
        text-align: center;
        width: 25.935vw;
        transition: all 1s;
    }
    .mobile-version.Exploration .heading-mbl.Exploration {
        font-weight: 600;
        font-size: 4.206vw;
        color: white;
        top: 11.215vw;
    }
    .mobile-version.Accerelation .heading-mbl.Accerelation,
    .mobile-version.Networking .heading-mbl.Networking,
    .mobile-version.Heroism .heading-mbl.Heroism {
        font-weight: 600;
        font-size: 4.206vw;
        color: white;
        top: 34.579vw;
    }
    .mobile-version.Exploration .heading-mbl.Heroism {
        font-size: 2.804vw;
        top: 152.103vw;
    }
    .mobile-version.Heroism .heading-mbl.Exploration {
        font-size: 2.804vw;
        top: 4.673vw;
    }
    .mobile-version.Exploration .heading-mbl.Networking {
        font-size: 3.271vw;
        top: 143.458vw;
    }
    .mobile-version.Accerelation .heading-mbl.Heroism {
        font-size: 3.271vw;
        top: 166.822vw;
    }
    .mobile-version.Heroism .heading-mbl.Accerelation,
    .mobile-version.Networking .heading-mbl.Exploration {
        font-size: 3.271vw;
        top: 10.981vw;
    }
    .mobile-version.Accerelation .heading-mbl.Exploration,
    .mobile-version.Networking .heading-mbl.Accerelation,
    .mobile-version.Heroism .heading-mbl.Networking {
        font-size: 3.738vw;
        top: 18.458vw;
    }
    .mobile-version.Exploration .heading-mbl.Accerelation {
        font-size: 3.738vw;
        top: 134.813vw;
    }
    .mobile-version.Accerelation .heading-mbl.Networking,
    .mobile-version.Networking .heading-mbl.Heroism {
        font-size: 3.738vw;
        top: 158.411vw;
    }
    .description-inner-mbl.Exploration {
        top: 23.832vw;
    }
    .mobile-version.Exploration .description-inner-mbl.Exploration {
        opacity: 1;
    }
    .description-inner-mbl.Accerelation,
    .description-inner-mbl.Networking,
    .description-inner-mbl.Heroism {
        top: 47.897vw;
    }
    .mobile-version.Accerelation .description-inner-mbl.Accerelation,
    .mobile-version.Networking .description-inner-mbl.Networking,
    .mobile-version.Heroism .description-inner-mbl.Heroism {
        opacity: 1;
    }
</style>
